// @flow

import React from "react";

import { isNil } from "ramda";

import {
  type State,
  getEdicaoMedida,
  getExibirConfiguracoesAvancadas,
  analiseValorDaMedida,
} from "../../../state";
import {
  SelecaoDeflacao,
  SelecaoNormalizacao,
  SelecaoCorrecaoMonetaria,
} from "../configuracoes";
import {
  type MedidaSelecionada,
  ID_OPCAO_DEFLATOR_NENHUM,
  ID_OPCAO_CORRETOR_MONETARIO_NENHUM,
} from "../../../model";

export const processarSeriesComDeflatorCorrecao = (
  state: State,
  medidas: Array<MedidaSelecionada>
): Array<MedidaSelecionada> => {
  const edicaoMedida = getEdicaoMedida(state);
  const exibirConfiguracoesAvancadas = getExibirConfiguracoesAvancadas(state);

  return medidas.map(medida => {
    if (exibirConfiguracoesAvancadas) {
      const configCorrecao =
        !isNil(edicaoMedida.corretorMonetario) &&
        edicaoMedida.corretorMonetario !== ID_OPCAO_CORRETOR_MONETARIO_NENHUM
          ? {
              correcaoMonetaria: edicaoMedida.corretorMonetario,
            }
          : {};
      const configDeflator =
        !isNil(edicaoMedida.deflator) &&
        edicaoMedida.deflator !== ID_OPCAO_DEFLATOR_NENHUM
          ? {
              deflator: edicaoMedida.deflator,
            }
          : {};

      const configValorDataBase =
        !isNil(edicaoMedida.valorBaseDeflator) &&
        !isNil(edicaoMedida.dataBaseDeflator)
          ? {
              valorBaseDeflator: edicaoMedida.valorBaseDeflator,
              valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
              dataBaseDeflator: edicaoMedida.dataBaseDeflator,
              dataBaseDeflatorDataEspecifica:
                edicaoMedida.dataBaseDeflatorDataEspecifica,
            }
          : {};

      return {
        ...medida,
        ...configCorrecao,
        ...configDeflator,
        ...configValorDataBase,
        ...analiseValorDaMedida(medida, state),
      };
    } else {
      return {
        ...medida,
        ...analiseValorDaMedida(medida, state),
      };
    }
  });
};

const SeriesComDeflatorCorrecao = () => {
  return (
    <>
      <div className="ConfiguracaoMedida__box">
        <div className="ConfiguracaoMedida--row">
          <SelecaoDeflacao exibirNormalizacao={false} />
          <SelecaoCorrecaoMonetaria />
        </div>
        <div className="ConfiguracaoMedida--row">
          <SelecaoNormalizacao
            forcarExibirNormalizacao={true}
            exibirOpcaoNenhum={true}
            utilizarEspacoTotal={true}
          />
        </div>
      </div>
    </>
  );
};

export default SeriesComDeflatorCorrecao;
